import { ClientWorkstreamData } from '@modules/EvaluationModule/interfaces/ClientWorkstreamData';
import { WorkstreamStatus } from '../enums/ContactFilterOptions';

/** Same id the backend gives the pseudo-workstream, and contactCache.ts's bucket key for it. */
export const pseudoWorkstreamId = (clientId: string): string => `account_${clientId}`;

/**
 * The rows a client's table shows: the DB workstreams from /my-projects-list — on screen
 * immediately — then any workstream only Zoho knows about, once the per-client check returns.
 * Rows already shown keep their DB values, so the check only ever adds rows. Closed rows come after
 * the active ones (they're hidden unless "Show closed" is on), and the pseudo row ("Not associated
 * with workstreams") is always last.
 */
export const mergeWorkstreams = (
  clientId: string,
  dbWorkstreams: ClientWorkstreamData[],
  zohoWorkstreams: ClientWorkstreamData[] | null
): ClientWorkstreamData[] => {
  const pseudo = zohoWorkstreams?.find((ws) => !ws.isWorkstream) ?? {
    name: 'Not associated with workstreams',
    zoho_crm_id: pseudoWorkstreamId(clientId),
    isWorkstream: false,
    status: null,
    contacts: [],
  };
  const dbIds = new Set(dbWorkstreams.map((ws) => ws.zoho_crm_id));
  const zohoOnly = (zohoWorkstreams ?? []).filter((ws) => ws.isWorkstream && !dbIds.has(ws.zoho_crm_id));
  const real = [...dbWorkstreams, ...zohoOnly];
  const isClosed = (ws: ClientWorkstreamData) => ws.status === WorkstreamStatus.Closed;

  return [...real.filter((ws) => !isClosed(ws)), ...real.filter(isClosed), pseudo];
};
